import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';

import CommonTable from '../../CommonTable/CommonTable';
import CurrencyConverter from '../../CurrencyConverter';
import Link from '../../Link';

import messages from '../../../locale/messages';
import { isValidJSON } from '../../../helpers/isValidJSON';

import bt from '../../../components/commonStyle.css';
import s from './ShowFailedPayout.css';

class ShowFailedPayout extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
    }

    thead = () => {
        const { formatMessage } = this.props.intl;
        return [
            { data: formatMessage(messages.reservationId) },
            { data: formatMessage(messages.codeLabel) },
            { data: formatMessage(messages.adminListTitle) },
            { data: formatMessage(messages.hostNameLabel) },
            { data: formatMessage(messages.payoutLabel) },
            { data: formatMessage(messages.reason) },
        ];
    }

    tbody = () => {
        const { data } = this.props;
        const { formatMessage } = this.props.intl;

        if (!data) return [];

        let payoutAmount = data?.total - data?.hostServiceFee, checkJSON;
        let reason = data?.hostFailedTransaction && data?.hostFailedTransaction?.reason;

        checkJSON = isValidJSON(reason);
        reason = checkJSON ? JSON.parse(reason) : reason;

        return [
            {
                id: data?.id,
                data: [
                    { data: data?.id },
                    { data: data?.confirmationCode },
                    {
                        data: data?.listData ? (
                            <a href={"/rooms/" + data.listData.id} target='_blank' rel="noreferrer">
                                {data?.listData?.title}
                            </a>
                        ) : formatMessage(messages.dataMissing)
                    },
                    { data: data?.hostData?.firstName },
                    {
                        data: <CurrencyConverter
                            amount={payoutAmount}
                            from={data?.currency}
                        />
                    },
                    { data: reason?.raw?.message ? reason?.raw?.message : reason },
                ]
            }
        ];
    }

    render() {
        const { title } = this.props;

        return (
            <div className={cx(s.pagecontentWrapper, 'pagecontentAR')}>
                <div>
                    <h1 className={s.headerTitle}>{title}</h1>
                    <div className={cx(s.space4, bt.textAlignRight)}>
                        <Link to={'/siteadmin/payout'} className={cx(bt.btnPrimaryBorder, bt.btnLarge, bt.noTextDecoration, 'bgBlack')}>
                            <FormattedMessage {...messages.goBack} />
                        </Link>
                    </div>
                    <CommonTable
                        thead={this.thead}
                        tbody={this.tbody}
                    />
                </div>
            </div>
        )
    }
}

export default injectIntl(withStyles(s, bt)(ShowFailedPayout));